/* aogen-forms asset republish 2026-09-17 (NZ CDN) */
/**
 * AOGEN Connect Forms — Theme App Extension storefront runtime.
 * Uses public CORS API on adapter (not Shopify app proxy).
 */
(function () {
  var ATTR_MOUNTED = "data-aogen-mounted";

  function apiBase(root) {
    return (root.getAttribute("data-api-base") || "").trim().replace(/\/+$/, "");
  }

  function shopDomain(root) {
    return (root.getAttribute("data-shop") || "").trim();
  }

  function definitionUrl(root, formKey) {
    return (
      apiBase(root) +
      "/api/public/forms/definition?shop=" +
      encodeURIComponent(shopDomain(root)) +
      "&form_key=" +
      encodeURIComponent(formKey)
    );
  }

  function submitUrl(root) {
    return apiBase(root) + "/api/public/forms/submit";
  }

  function viewUrl(root) {
    return apiBase(root) + "/api/public/forms/view";
  }

  function landingPage() {
    try {
      var key = "aogen_forms_landing";
      var existing = sessionStorage.getItem(key);
      if (existing) return existing;
      sessionStorage.setItem(key, window.location.href);
      return window.location.href;
    } catch (e) {
      return window.location.href;
    }
  }

  var BOOKING_CONTEXT_ATTRS = {
    product_id: "data-product-id",
    product_name: "data-product-name",
    product_handle: "data-product-handle",
    venue_id: "data-venue-id",
    venue_name: "data-venue-name",
    workshop_type: "data-workshop-type",
    city: "data-city",
    state: "data-state",
    country: "data-country",
    available_event_dates: "data-available-event-dates",
  };

  function contextFromRoot(root) {
    var params = new URLSearchParams(window.location.search || "");
    function attr(name) {
      return root.getAttribute(name) || "";
    }
    function q(name) {
      return params.get(name) || "";
    }
    return {
      product_id: attr("data-product-id") || q("product_id"),
      product_name: attr("data-product-name") || q("product_name"),
      product_handle: attr("data-product-handle") || q("product_handle"),
      venue_id: attr("data-venue-id") || q("venue_id"),
      venue_name: attr("data-venue-name") || q("venue_name"),
      workshop_type: attr("data-workshop-type") || q("workshop_type"),
      city: attr("data-city") || q("city"),
      state: attr("data-state") || q("state"),
      country: attr("data-country") || q("country"),
      page_url: window.location.href,
      landing_page: landingPage(),
      referrer: document.referrer || "",
      utm_source: q("utm_source"),
      utm_medium: q("utm_medium"),
      utm_campaign: q("utm_campaign"),
      utm_content: q("utm_content"),
      utm_term: q("utm_term"),
      gclid: q("gclid"),
      fbclid: q("fbclid"),
      available_event_dates: attr("data-available-event-dates") || q("available_event_dates"),
    };
  }

  function normalizeBookingContextDetail(raw) {
    if (!raw || typeof raw !== "object") return {};
    var detail = raw;
    var out = {};
    function pick(key) {
      var v = detail[key];
      if (v == null) return;
      var s = String(v).trim();
      if (s) out[key] = s;
    }
    pick("product_id");
    pick("product_name");
    pick("product_handle");
    pick("venue_id");
    if (!out.venue_id) pick("venue_ref_id");
    pick("venue_name");
    pick("workshop_type");
    pick("city");
    pick("state");
    pick("country");
    pick("available_event_dates");
    return out;
  }

  function mergeContext(root) {
    var base = contextFromRoot(root);
    var overlay = root._aogenBookingContext || {};
    var out = {};
    Object.keys(base).forEach(function (k) {
      out[k] = base[k];
    });
    Object.keys(overlay).forEach(function (k) {
      if (overlay[k] != null && String(overlay[k]).trim() !== "") out[k] = String(overlay[k]).trim();
    });
    return out;
  }

  function applyBookingContextAttrs(root, detail) {
    var norm = normalizeBookingContextDetail(detail);
    root._aogenBookingContext = norm;
    var runtimeKeys = [
      "venue_id",
      "venue_name",
      "city",
      "state",
      "country",
      "available_event_dates",
    ];
    runtimeKeys.forEach(function (key) {
      var attrName = BOOKING_CONTEXT_ATTRS[key];
      if (norm[key]) root.setAttribute(attrName, norm[key]);
      else root.removeAttribute(attrName);
    });
    ["product_id", "product_name", "product_handle", "workshop_type"].forEach(function (key) {
      if (!norm[key]) return;
      root.setAttribute(BOOKING_CONTEXT_ATTRS[key], norm[key]);
    });
  }

  function refreshBookingContextUi(root) {
    if (root.getAttribute("data-aogen-ready") !== "1") return;
    var ctx = mergeContext(root);
    var ui = root._aogenUi || {};
    var head = headFor(root);
    if (head) {
      head.innerHTML = "";
      var title = fillTemplate(ui.title_template || ui.title || "", ctx);
      var intro = fillTemplate(ui.intro_template || ui.intro || "", ctx);
      if (title) head.appendChild(el("h3", { className: "aogen-forms-title", text: title }));
      if (intro) head.appendChild(el("p", { className: "aogen-forms-intro", text: intro }));
    }
    var schema = root._aogenFieldsSchema || [];
    var panel = panelFor(root);
    var form = panel ? panel.querySelector(".aogen-forms-form") : root.querySelector(".aogen-forms-form");
    schema.forEach(function (field) {
      if (!field || normalizeType(field.type) !== "hidden" || !field.key) return;
      var auto = field.auto_from ? ctx[field.auto_from] || "" : "";
      var input = form ? form.querySelector('input[type="hidden"][name="' + field.key + '"]') : null;
      if (input) input.value = auto;
    });
    renderConsentNotices(root, schema, ctx);
  }

  function mergeHiddenAutoFrom(submitted, schema, ctx) {
    var out = submitted && typeof submitted === "object" ? Object.assign({}, submitted) : {};
    (schema || []).forEach(function (field) {
      if (!field || !field.key || normalizeType(field.type) !== "hidden") return;
      if (!field.auto_from) return;
      var auto = ctx[field.auto_from];
      if (auto != null && String(auto).trim() !== "") out[field.key] = String(auto).trim();
    });
    return out;
  }

  function schemaRequiresVenue(schema) {
    return (schema || []).some(function (field) {
      return field && field.key === "venue_id" && normalizeType(field.type) === "hidden";
    });
  }

  function forceOpenBookingPopup(root) {
    var panel = panelFor(root);
    if (!panel) return;
    panel.hidden = false;
    var ov = ensureOverlay(root, panel);
    document.body.appendChild(ov);
    ov.setAttribute("data-drawer-side", "bottom");
    ov.setAttribute("data-popup-style", "overlay");
    ov.setAttribute("data-template", (root._aogenUi && root._aogenUi.template) || "card");
    ov.removeAttribute("data-position");
    ov.classList.add("is-drawer-surface", "is-open");
    ov.classList.remove("is-floating", "is-overlay");
    if (panel.style) {
      panel.style.transform = "none";
      panel.style.left = "";
      panel.style.right = "";
      panel.style.top = "";
      panel.style.bottom = "";
    }
    ov.hidden = false;
    root.classList.add("is-open", "is-popup", "is-drawer");
    var s = root._aogenSurface;
    if (s && s.teaser) s.teaser.hidden = true;
    root._aogenBookingPopupOpen = true;
    recordDisplayView(root, formKeyFor(root));
  }

  function isFormsBlockVisible(root) {
    if (!root || root.hasAttribute("hidden")) return false;
    try {
      var style = window.getComputedStyle(root);
      if (style.display === "none" || style.visibility === "hidden") return false;
    } catch (err) {}
    return !!(root.offsetWidth || root.offsetHeight || root.getClientRects().length);
  }

  function pickBookingPopupBlock(roots) {
    for (var i = 0; i < roots.length; i++) {
      if (isFormsBlockVisible(roots[i])) return roots[i];
    }
    return roots[0] || null;
  }

  function handleBookingContextEvent(e) {
    var detail = (e && e.detail) || {};
    var intent = String(detail.intent || "inline").trim().toLowerCase();
    var formKey = String(detail.form_key || "waitlist").trim();
    var matched = [];
    document.querySelectorAll(".aogen-forms-block").forEach(function (root) {
      var key = (root.getAttribute("data-form-key") || "").trim();
      if (key !== formKey) return;
      matched.push(root);
      applyBookingContextAttrs(root, detail);
      if (root.getAttribute("data-aogen-ready") === "1") refreshBookingContextUi(root);
    });
    if (intent !== "popup" || !matched.length) return;
    var popupRoot = pickBookingPopupBlock(matched);
    if (!popupRoot) return;
    matched.forEach(function (root) {
      if (root !== popupRoot) root._aogenOpenPopupWhenReady = false;
    });
    if (popupRoot.getAttribute("data-aogen-ready") === "1") {
      forceOpenBookingPopup(popupRoot);
    } else {
      popupRoot._aogenOpenPopupWhenReady = true;
    }
  }

  function fillTemplate(tpl, ctx) {
    return String(tpl || "").replace(/\{\{\s*([a-z0-9_]+)\s*\}\}/gi, function (_, key) {
      return ctx[key] != null && ctx[key] !== "" ? String(ctx[key]) : "";
    });
  }

  function pushDataLayer(eventName, ctx, extra) {
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = {
        event: eventName,
        form_key: (extra && extra.form_key) || "",
        waitlist_city: ctx.city || "",
        waitlist_state: ctx.state || "",
        waitlist_country: ctx.country || "",
        waitlist_workshop_type: ctx.workshop_type || "",
        waitlist_product_name: ctx.product_name || "",
        waitlist_venue_id: ctx.venue_id || "",
        waitlist_product_id: ctx.product_id || "",
        waitlist_page_url: ctx.page_url || window.location.href,
        waitlist_utm_source: ctx.utm_source || "",
        waitlist_utm_medium: ctx.utm_medium || "",
        waitlist_utm_campaign: ctx.utm_campaign || "",
      };
      if (extra) {
        Object.keys(extra).forEach(function (k) {
          payload[k] = extra[k];
        });
      }
      window.dataLayer.push(payload);
    } catch (e) {}
  }

  /**
   * Meta Pixel Lead — only after a real accepted submission (never camouflage / never clicks).
   * Requires window.fbq (classic Pixel base code or GTM). Shopify Customer Events sandbox
   * may not expose fbq on window — verify on target shops.
   * Do not also fire Lead from GTM on the same submit or events will double-count.
   */
  function trackMetaLead(ctx, formKey) {
    try {
      if (typeof window.fbq !== "function") return;
      var key = String(formKey || "").trim();
      var params = {
        content_category: "lead_form",
        content_name: key || ctx.product_name || "form",
      };
      if (key) params.form_key = key;
      if (ctx.product_id) params.content_ids = [String(ctx.product_id)];
      if (ctx.city) params.city = String(ctx.city);
      // Standard Lead for ads optimization (waitlist / private / corporate / any Connect form).
      window.fbq("track", "Lead", params);
      // Custom mirror for reporting filters in Events Manager.
      window.fbq("trackCustom", "FormSubmit", {
        form_key: key,
        content_name: params.content_name,
      });
    } catch (e) {}
  }

  /** True only for persisted accepts — camouflage returns { ok: true } without id. */
  function isRealAcceptedSubmission(body) {
    return !!(body && body.ok && body.id);
  }

  /** dataLayer + optional Meta Lead — call once on real API accept only. */
  function trackFormSubmitSuccess(root, ctx, body) {
    if (!isRealAcceptedSubmission(body)) return;
    var formKey = (root && root.getAttribute("data-form-key")) || "";
    var extra = { form_key: formKey, submission_id: String(body.id) };
    pushDataLayer("waitlist_form_submit", ctx, extra);
    var ui = (root && root._aogenUi) || {};
    // Default on; admin can set ui.meta_lead = false per form.
    if (ui.meta_lead !== false) trackMetaLead(ctx, formKey);
  }

  function redirectAfterSubmit(url) {
    var href = String(url || "").trim();
    if (!href) return;
    // Give the pixel a beat to queue the Lead beacon before unload.
    window.setTimeout(function () {
      window.location.assign(href);
    }, 250);
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (attrs[k] === false || attrs[k] == null) return;
        if (k === "className") node.className = attrs[k];
        else if (k === "text") node.textContent = attrs[k];
        else node.setAttribute(k, attrs[k]);
      });
    }
    (children || []).forEach(function (c) {
      if (c) node.appendChild(c);
    });
    return node;
  }

  function setMessage(msg, text, isError) {
    if (!msg) return;
    msg.hidden = !text;
    msg.textContent = text || "";
    if (isError) {
      msg.setAttribute("data-error", "1");
      msg.classList.add("is-error");
    } else {
      msg.removeAttribute("data-error");
      msg.classList.remove("is-error");
    }
    var block = msg.closest ? msg.closest(".aogen-forms-block") : null;
    if (block) {
      if (isError && text) {
        block.setAttribute("data-aogen-error", "1");
        var errPanel = block.querySelector(".aogen-forms-panel");
        if (errPanel) errPanel.hidden = false;
      } else {
        block.removeAttribute("data-aogen-error");
      }
    }
  }

  function fieldDisplayLabel(schema, key) {
    var list = Array.isArray(schema) ? schema : [];
    for (var i = 0; i < list.length; i++) {
      var f = list[i];
      if (f && f.key === key) {
        return String(f.label || f.consentText || f.key || key);
      }
    }
    return key;
  }

  function humanizeFieldError(fieldKey, message, schema) {
    var label = fieldDisplayLabel(schema, fieldKey);
    var code = String(message || "").trim().toLowerCase();
    var fieldMeta = null;
    var list = Array.isArray(schema) ? schema : [];
    for (var i = 0; i < list.length; i++) {
      if (list[i] && list[i].key === fieldKey) {
        fieldMeta = list[i];
        break;
      }
    }
    var fieldType = fieldMeta ? normalizeType(fieldMeta.type) : "";
    if (code === "required") {
      if (fieldKey === "email" || fieldType === "email") {
        return "Please enter your email.";
      }
      if (fieldKey === "name" || fieldKey === "full_name" || fieldKey === "first_name") {
        return "Please enter your name.";
      }
      return 'Please fill in "' + label + '".';
    }
    if (code === "consent is required" || (fieldType === "consent" && code === "required")) {
      return 'Please check "' + label + '" to continue.';
    }
    if (code === "invalid email") {
      return "Please enter a valid email address.";
    }
    if (code === "invalid number") {
      return '"' + label + '" must be a number.';
    }
    if (code === "invalid date") {
      return '"' + label + '" must be a valid date.';
    }
    if (code === "invalid option") {
      return 'Please choose a valid option for "' + label + '".';
    }
    if (code.indexOf("file too large") !== -1) {
      return '"' + label + '": file is too large (max 2MB).';
    }
    if (code.indexOf("unsupported file") !== -1) {
      return '"' + label + '": that file type is not supported.';
    }
    if (code.indexOf("invalid file") !== -1 || code.indexOf("file data") !== -1) {
      return '"' + label + '": please choose a valid file.';
    }
    return '"' + label + '": ' + message;
  }

  function cssAttrEscape(value) {
    var s = String(value == null ? "" : value);
    if (window.CSS && typeof window.CSS.escape === "function") return window.CSS.escape(s);
    return s.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  }

  function nameSelector(key) {
    return '[name="' + cssAttrEscape(key) + '"]';
  }

  function localErrorType(errors) {
    if (!errors || !errors.length) return "required_field_missing";
    var first = String((errors[0] && errors[0].message) || "").toLowerCase();
    if (first === "invalid email") return "invalid_email";
    if (first.indexOf("consent") !== -1) return "consent_required";
    if (first === "required") return "required_field_missing";
    return "validation_error";
  }

  function formatValidationDetails(details, schema) {
    if (!Array.isArray(details) || details.length === 0) return "";
    var lines = [];
    details.forEach(function (d) {
      if (!d) return;
      var field = d.field || d.path || "";
      var message = d.message || d.msg || "";
      if (!field && !message) return;
      if (field) lines.push(humanizeFieldError(String(field), String(message || "invalid"), schema));
      else lines.push(String(message));
    });
    return lines.join("\n");
  }

  function explainSubmitFailure(result, schema) {
    if (!result) return "Could not submit. Please try again.";
    if (result.passwordWall) return explainLoadFailure(result);
    if (result.parseError) {
      return "Could not reach AOGEN Forms API (non-JSON response). Check API base URL in the block settings.";
    }
    var body = result.body && typeof result.body === "object" ? result.body : null;
    if (body) {
      var fromDetails = formatValidationDetails(body.details, schema);
      if (fromDetails) return fromDetails;
      var code = String(body.error_code || body.error || "");
      if (code === "validation_error") {
        return "Please fix the highlighted fields and try again.";
      }
      if (code === "form_not_found") return "This form is not active in AOGEN Connect.";
      if (code === "browser_required") {
        return "Could not submit from this browser. Please try again in a normal browser tab.";
      }
      if (code === "shop_required" || code === "shop_unknown" || code === "shop_not_registered") {
        return "This shop is not connected to AOGEN Connect.";
      }
      if (code === "server_error") return "Server error while saving. Please try again in a moment.";
      if (body.message) return String(body.message);
      if (code && code !== "validation_error") return "Could not submit (" + code + ").";
    }
    if (result.status === 422) return "Please complete the required fields.";
    if (result.status) return "Could not submit (HTTP " + result.status + ").";
    return "Could not submit. Please try again.";
  }

  function clearFieldInvalid(form) {
    if (!form) return;
    form.querySelectorAll("[aria-invalid='true']").forEach(function (node) {
      node.removeAttribute("aria-invalid");
    });
  }

  function markFieldInvalid(form, key) {
    if (!form || !key) return;
    var nodes = form.querySelectorAll(nameSelector(key));
    nodes.forEach(function (node) {
      node.setAttribute("aria-invalid", "true");
    });
  }

  function readFieldValue(form, field) {
    var type = normalizeType(field.type);
    var key = field.key;
    if (type === "consent") {
      if (consentStyle(field) === "notice") return true;
      var box = form.querySelector(nameSelector(key) + '[type="checkbox"]');
      return !!(box && box.checked);
    }
    if (type === "multiselect") {
      var checked = form.querySelectorAll(nameSelector(key) + "[data-multiselect]:checked");
      return Array.prototype.map.call(checked, function (n) {
        return n.value;
      });
    }
    if (type === "radio") {
      var rad = form.querySelector(nameSelector(key) + ":checked");
      return rad ? rad.value : "";
    }
    if (type === "file") {
      var file = form.querySelector(nameSelector(key) + '[type="file"]');
      return file && file.files && file.files[0] ? file.files[0] : null;
    }
    var input = form.querySelector(nameSelector(key));
    return input ? String(input.value || "").trim() : "";
  }

  /** Client-side checks before network — returns human lines + field keys. */
  function validateLocalSubmission(form, schema) {
    var errors = [];
    var fields = Array.isArray(schema) ? schema : [];
    fields.forEach(function (field) {
      if (!field || !field.key) return;
      var type = normalizeType(field.type);
      if (type === "hidden") return;
      var required = !!field.required;
      var value = readFieldValue(form, field);
      var label = field.label || field.consentText || field.key;

      if (type === "consent") {
        if (consentStyle(field) === "notice") return;
        if (required && !value) {
          errors.push({ field: field.key, message: "consent is required", label: label });
        }
        return;
      }
      if (type === "multiselect") {
        if (required && (!value || !value.length)) {
          errors.push({ field: field.key, message: "required", label: label });
        }
        return;
      }
      if (type === "file") {
        if (required && !value) {
          errors.push({ field: field.key, message: "required", label: label });
        }
        return;
      }
      var empty = value === "" || value == null;
      if (required && empty) {
        errors.push({ field: field.key, message: "required", label: label });
        return;
      }
      if (!empty && type === "email") {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).toLowerCase())) {
          errors.push({ field: field.key, message: "invalid email", label: label });
        }
      }
    });
    return errors;
  }

  function explainLoadFailure(result) {
    if (result.passwordWall) {
      return "Store password wall blocked the form request. Unlock the storefront password, then reload.";
    }
    if (result.parseError) {
      return "Could not reach AOGEN Forms API (non-JSON response). Check API base URL in the block settings.";
    }
    if (!result.body || typeof result.body !== "object") {
      return (
        "Form unavailable (empty HTTP " +
        (result.status || "?") +
        "). Check API base URL and that the shop is connected in AOGEN Connect."
      );
    }
    var code = result.body.error_code || result.body.error || "";
    if (code === "form_not_found" || result.status === 404) {
      return "No active form with this form key in AOGEN Connect.";
    }
    if (code === "form_key_required") {
      return "Form key is missing.";
    }
    if (code === "shop_unknown" || code === "shop_not_registered" || code === "shop_lookup_failed") {
      return "This shop is not connected to AOGEN Connect.";
    }
    if (result.status === 401 || result.status === 403) {
      return "Forms API rejected the request (" + (code || result.status) + ").";
    }
    return "Form unavailable" + (code ? " (" + code + ")" : "") + ".";
  }

  /** Safe parse: never throws on HTML/empty bodies (theme editor / misconfigured proxy). */
  function readJson(res) {
    return res.text().then(function (text) {
      var trimmed = String(text || "").trim();
      if (!trimmed) {
        return { ok: res.ok, status: res.status, body: null, empty: true };
      }
      try {
        return { ok: res.ok, status: res.status, body: JSON.parse(trimmed) };
      } catch (e) {
        return { ok: false, status: res.status, body: null, parseError: true };
      }
    });
  }

  function isShopifyThemeEditor() {
    try {
      return !!(window.Shopify && window.Shopify.designMode);
    } catch (e) {
      return false;
    }
  }

  function formKeyFor(root) {
    return (root.getAttribute("data-form-key") || "").trim();
  }

  /** POST view beacon (Shopify Forms parity: count when displayed, not on silent mount). */
  function recordView(root, formKey) {
    try {
      fetch(viewUrl(root), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "omit",
        body: JSON.stringify({
          shop: shopDomain(root),
          form_key: formKey,
          page_url: window.location.href,
        }),
        keepalive: true,
      }).catch(function () {});
    } catch (e) {}
  }

  function recordDisplayView(root, formKey) {
    if (!root || !formKey || isShopifyThemeEditor()) return;
    recordView(root, formKey);
  }

  function disarmDisplayViewTracking(root) {
    if (!root || !root._aogenViewObserver) return;
    try {
      root._aogenViewObserver.disconnect();
    } catch (e) {}
    root._aogenViewObserver = null;
  }

  /** Inline: one impression per page load when the block enters the viewport. */
  function armInlineDisplayViewTracking(root, formKey) {
    if (!root || !formKey || isShopifyThemeEditor()) return;
    var ui = root._aogenUi || {};
    var display = ui.display || ui.mode || "inline";
    if (display !== "inline") return;
    if (root._aogenInlineViewRecorded) return;
    disarmDisplayViewTracking(root);

    function markInlineView() {
      if (root._aogenInlineViewRecorded) return;
      if (!isFormsBlockVisible(root)) return;
      root._aogenInlineViewRecorded = true;
      recordDisplayView(root, formKey);
      disarmDisplayViewTracking(root);
    }

    if (typeof IntersectionObserver === "undefined") {
      markInlineView();
      return;
    }

    root._aogenViewObserver = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting && entries[i].target === root) {
            markInlineView();
            return;
          }
        }
      },
      { threshold: 0.1 },
    );
    root._aogenViewObserver.observe(root);
  }

  function fetchFormsApi(url, options) {
    var opts = options || {};
    var headers = Object.assign({}, opts.headers || {});
    delete headers.Accept;
    delete headers.accept;
    return fetch(
      url,
      Object.assign({}, opts, {
        credentials: "omit",
        headers: headers,
        redirect: "follow",
      }),
    ).then(function (res) {
      return readJson(res).then(function (result) {
        return { http: res, result: result };
      });
    });
  }

  function normalizeType(type) {
    return type === "enum" ? "dropdown" : type || "text";
  }

  function consentStyle(field) {
    return field && field.consent_style === "notice" ? "notice" : "checkbox";
  }

  function normalizeSuccessDiscount(raw) {
    if (!raw || typeof raw !== "object") return null;
    var gid = String(raw.gid || "").trim();
    var code = String(raw.code || "").trim();
    var title = String(raw.title || "").trim();
    var mode = String(raw.mode || "").trim().toLowerCase() === "unique" ? "unique" : "shared";
    if (!gid) return null;
    if (mode === "shared" && !code) return null;
    return { mode: mode, gid: gid, code: code, title: title };
  }

  function normalizeSuccess(ui) {
    var raw = ui && ui.success && typeof ui.success === "object" ? ui.success : {};
    var legacy = String((ui && ui.success_template) || "").trim();
    var message = String(raw.message || raw.text || legacy || "").trim();
    return {
      action: raw.action === "redirect" ? "redirect" : "show_message",
      message: message,
      redirect_url: String(raw.redirect_url || raw.url || "").trim(),
      heading: String(raw.heading || "").trim(),
      discount: normalizeSuccessDiscount(raw.discount),
    };
  }

  function fallbackCopy(text) {
    var ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand("copy");
    } catch (e) {}
    ta.remove();
  }

  function renderSuccessContent(root, successCfg, liveCtx) {
    var panel = panelFor(root);
    var msg =
      (panel && panel.querySelector(".aogen-forms-msg")) || root.querySelector(".aogen-forms-msg");
    if (!msg) return;
    msg.hidden = false;
    msg.removeAttribute("data-error");
    msg.classList.remove("is-error");
    msg.innerHTML = "";
    var heading = successCfg.heading ? fillTemplate(successCfg.heading, liveCtx) : "";
    var body =
      fillTemplate(successCfg.message || "", liveCtx) ||
      root.getAttribute("data-success") ||
      "Thanks!";
    if (heading) msg.appendChild(el("p", { className: "aogen-forms-success-heading", text: heading }));
    var disc = successCfg.discount;
    if (disc && disc.code && successCfg.action !== "redirect") {
      var row = el("div", { className: "aogen-forms-discount" });
      row.appendChild(el("div", { className: "aogen-forms-discount-code", text: disc.code }));
      var copyBtn = el("button", {
        type: "button",
        className: "aogen-forms-discount-copy",
        text: "Copy",
      });
      copyBtn.addEventListener("click", function () {
        var done = function () {
          copyBtn.textContent = "Copied!";
          setTimeout(function () {
            copyBtn.textContent = "Copy";
          }, 1500);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(disc.code).then(done).catch(function () {
            fallbackCopy(disc.code);
            done();
          });
        } else {
          fallbackCopy(disc.code);
          done();
        }
      });
      row.appendChild(copyBtn);
      msg.appendChild(row);
      if (disc.title) {
        msg.appendChild(el("p", { className: "aogen-forms-discount-title", text: disc.title }));
      }
    }
    if (body) msg.appendChild(el("p", { className: "aogen-forms-success-body", text: body }));
  }

  function disclaimerHostFor(root) {
    var panel = panelFor(root);
    var form =
      (panel && panel.querySelector(".aogen-forms-form")) || root.querySelector(".aogen-forms-form");
    if (!form) return null;
    var host = form.querySelector("[data-aogen-disclaimer]");
    if (!host) {
      host = el("div", { className: "aogen-forms-disclaimer-host", "data-aogen-disclaimer": "1" });
      var btn = form.querySelector('button[type="submit"]');
      if (btn && btn.parentNode) btn.parentNode.insertBefore(host, btn.nextSibling);
      else form.appendChild(host);
    }
    return host;
  }

  function renderConsentNotices(root, schema, ctx) {
    var host = disclaimerHostFor(root);
    if (!host) return;
    host.innerHTML = "";
    (schema || []).forEach(function (field) {
      if (!field || normalizeType(field.type) !== "consent") return;
      if (consentStyle(field) !== "notice") return;
      var text = field.label || field.consentText || "";
      if (!text) return;
      host.appendChild(
        el("p", {
          className: "aogen-forms-disclaimer",
          text: fillTemplate(text, ctx),
        }),
      );
    });
  }

  function resolveRedirectUrl(raw) {
    var url = String(raw || "").trim();
    if (!url) return "";
    if (/^https?:\/\//i.test(url)) return url;
    if (url.indexOf("//") === 0) return window.location.protocol + url;
    if (url.charAt(0) === "/") return window.location.origin + url;
    return "https://" + url.replace(/^\/+/, "");
  }

  function clickBindSessionKey(root, formKey) {
    return "aogen_forms_click:" + shopDomain(root) + ":" + formKey;
  }

  function hasClickBindSession(root, formKey) {
    try {
      return sessionStorage.getItem(clickBindSessionKey(root, formKey)) === "1";
    } catch (e) {
      return false;
    }
  }

  function markClickBindSession(root, formKey) {
    try {
      sessionStorage.setItem(clickBindSessionKey(root, formKey), "1");
    } catch (e) {}
  }

  function buildTrackOnlyPayload(schema, ctx) {
    var submitted = {};
    (schema || []).forEach(function (field) {
      if (!field || !field.key) return;
      var type = normalizeType(field.type);
      if (type === "hidden") {
        var auto = field.auto_from ? ctx[field.auto_from] || "" : "";
        if (auto !== "") submitted[field.key] = auto;
      } else if (type === "consent" && consentStyle(field) === "notice") {
        submitted[field.key] = true;
      }
    });
    return submitted;
  }

  function disarmClickBind(root) {
    if (root._aogenClickBindHandler) {
      document.removeEventListener("click", root._aogenClickBindHandler, true);
      root._aogenClickBindHandler = null;
    }
  }

  function armClickBind(root) {
    disarmClickBind(root);
    var ui = root._aogenUi || {};
    var bind = ui.click_bind || {};
    if (!bind.enabled) return;
    var selector = String(bind.selector || "").trim();
    if (!selector) return;
    var formKey = (root.getAttribute("data-form-key") || "").trim();
    if (!formKey) return;

    var handler = function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      var hit = null;
      try {
        hit = target.closest(selector);
      } catch (err) {
        return;
      }
      if (!hit || !document.contains(hit)) return;
      if (root.contains(hit)) return;

      if (hasClickBindSession(root, formKey)) return;

      var mode = bind.mode === "open_form" ? "open_form" : "track_only";
      var ctx = mergeContext(root);
      pushDataLayer("forms_click_bind", ctx, { mode: mode, selector: selector });

      if (mode === "open_form") {
        markClickBindSession(root, formKey);
        e.preventDefault();
        e.stopPropagation();
        var display = ui.display || ui.mode || "inline";
        if (display === "popup" || display === "drawer") {
          openSurface(root, "click_bind");
        } else {
          var panel = panelFor(root);
          if (panel) {
            panel.hidden = false;
            try {
              panel.scrollIntoView({ behavior: "smooth", block: "center" });
            } catch (err2) {
              panel.scrollIntoView();
            }
          }
        }
        return;
      }

      // track_only: do not block CTA navigation (links / buttons with href)
      markClickBindSession(root, formKey);
      var submitted = buildTrackOnlyPayload(root._aogenFieldsSchema || [], ctx);
      fetchFormsApi(submitUrl(root), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        keepalive: true,
        body: JSON.stringify({
          shop: shopDomain(root),
          form_key: formKey,
          submitted_data: submitted,
          source_url: window.location.href,
          track_only: true,
          bind_selector: selector,
        }),
      }).catch(function () {});
    };

    root._aogenClickBindHandler = handler;
    document.addEventListener("click", handler, true);
  }

  function renderField(field, ctx) {
    var type = normalizeType(field.type);
    var key = field.key;
    var label = field.label || field.consentText || key;
    var required = !!field.required;
    var options = Array.isArray(field.options) ? field.options : [];

    if (type === "hidden") {
      var auto = field.auto_from ? ctx[field.auto_from] || "" : "";
      return el("input", {
        type: "hidden",
        name: key,
        value: auto,
        "data-auto-from": field.auto_from || "",
      });
    }

    if (type === "consent") {
      if (consentStyle(field) === "notice") return null;
      var wrap = el("label", { className: "aogen-forms-consent" });
      wrap.appendChild(
        el("input", {
          type: "checkbox",
          name: key,
          value: "true",
          required: required ? "required" : false,
        }),
      );
      wrap.appendChild(el("span", { text: label }));
      return wrap;
    }

    if (type === "radio") {
      var fieldset = el("fieldset", { className: "aogen-forms-fieldset" });
      fieldset.appendChild(el("legend", { text: label }));
      options.forEach(function (opt, i) {
        var id = key + "_" + i;
        var row = el("label", { className: "aogen-forms-choice" });
        row.appendChild(
          el("input", {
            type: "radio",
            name: key,
            value: opt,
            id: id,
            required: required && i === 0 ? "required" : false,
          }),
        );
        row.appendChild(el("span", { text: opt }));
        fieldset.appendChild(row);
      });
      return fieldset;
    }

    if (type === "multiselect") {
      var mset = el("fieldset", { className: "aogen-forms-fieldset" });
      mset.appendChild(el("legend", { text: label }));
      options.forEach(function (opt) {
        var row = el("label", { className: "aogen-forms-choice" });
        row.appendChild(
          el("input", {
            type: "checkbox",
            name: key,
            value: opt,
            "data-multiselect": "1",
          }),
        );
        row.appendChild(el("span", { text: opt }));
        mset.appendChild(row);
      });
      if (required) mset.setAttribute("data-required-multiselect", key);
      return mset;
    }

    if (type === "dropdown") {
      var lab = el("label");
      lab.appendChild(el("span", { text: label }));
      var sel = el("select", { name: key, required: required ? "required" : false });
      sel.appendChild(el("option", { value: "", text: "—" }));
      options.forEach(function (opt) {
        sel.appendChild(el("option", { value: opt, text: opt }));
      });
      lab.appendChild(sel);
      return lab;
    }

    if (type === "textarea") {
      var tl = el("label");
      tl.appendChild(el("span", { text: label }));
      tl.appendChild(
        el("textarea", {
          name: key,
          required: required ? "required" : false,
          rows: "4",
        }),
      );
      return tl;
    }

    if (type === "file") {
      var fl = el("label");
      fl.appendChild(el("span", { text: label }));
      fl.appendChild(
        el("input", {
          type: "file",
          name: key,
          accept: ".gif,.heic,.jpeg,.jpg,.pdf,.svg,.webp,.xml,image/*,application/pdf",
          required: required ? "required" : false,
          "data-file-field": key,
        }),
      );
      return fl;
    }

    var inputType = "text";
    if (type === "email") inputType = "email";
    else if (type === "phone") inputType = "tel";
    else if (type === "number") inputType = "number";
    else if (type === "date" || type === "birthday") inputType = "date";

    var lab2 = el("label");
    lab2.appendChild(el("span", { text: label }));
    lab2.appendChild(
      el("input", {
        type: inputType,
        name: key,
        required: required ? "required" : false,
      }),
    );
    return lab2;
  }

  function sessionKeyFor(root) {
    return (
      "aogen_forms_shown_" +
      shopDomain(root) +
      "_" +
      (root.getAttribute("data-form-key") || "")
    );
  }

  function sessionShown(root) {
    try {
      return sessionStorage.getItem(sessionKeyFor(root)) === "1";
    } catch (e) {
      return false;
    }
  }

  function markSessionShown(root) {
    try {
      sessionStorage.setItem(sessionKeyFor(root), "1");
    } catch (e) {}
  }

  function copyThemeVars(fromEl, toEl) {
    if (!fromEl || !toEl || !toEl.style) return;
    var props = [
      "--aogen-forms-bg",
      "--aogen-forms-text",
      "--aogen-forms-btn",
      "--aogen-forms-btn-text",
      "--aogen-forms-font",
      "--aogen-forms-btn-radius",
      "--aogen-forms-title-size",
      "--aogen-forms-body-size",
      "--aogen-forms-input-bg",
      "--aogen-forms-input-border",
      "--aogen-forms-focus",
      "--aogen-forms-muted",
    ];
    var cs = window.getComputedStyle(fromEl);
    props.forEach(function (p) {
      var v = cs.getPropertyValue(p);
      if (v && String(v).trim()) toEl.style.setProperty(p, String(v).trim());
    });
  }

  function panelFor(root) {
    var s = root._aogenSurface;
    return (
      root.querySelector(".aogen-forms-panel") ||
      (s && s.overlay && s.overlay.querySelector(".aogen-forms-panel")) ||
      null
    );
  }

  function headFor(root) {
    var panel = panelFor(root);
    return (
      root.querySelector("[data-aogen-head]") ||
      (panel && panel.querySelector("[data-aogen-head]")) ||
      null
    );
  }

  function fieldsHostFor(root) {
    var panel = panelFor(root);
    return (
      root.querySelector("[data-aogen-fields]") ||
      (panel && panel.querySelector("[data-aogen-fields]")) ||
      null
    );
  }

  function disposeSurfaces(root) {
    var s = root._aogenSurface;
    if (!s) return;
    if (s.delayTimer) clearTimeout(s.delayTimer);
    if (s.onScroll) window.removeEventListener("scroll", s.onScroll);
    if (s.onExit) document.removeEventListener("mouseout", s.onExit);
    if (s.onEsc) document.removeEventListener("keydown", s.onEsc);
    if (s.overlay && s.overlay.parentNode) {
      var panel = s.overlay.querySelector(".aogen-forms-panel");
      if (panel && root) root.appendChild(panel);
      s.overlay.remove();
    }
    if (s.teaser && s.teaser.parentNode) s.teaser.remove();
    if (s.sticky && s.sticky.parentNode) s.sticky.remove();
    root.classList.remove("is-open", "is-popup", "is-drawer", "is-sticky", "is-floating");
    root._aogenSurface = null;
  }

  function placeCornerTeaser(root) {
    var s = root._aogenSurface;
    if (!s || !s.teaser) return;
    var ui = root._aogenUi || {};
    var display = ui.display || ui.mode || "inline";
    var mode = ui.teaser || "after-close";
    var show =
      display === "popup" &&
      mode !== "off" &&
      !s.teaserDismissed &&
      !s.submitted &&
      (mode === "always" || (mode === "after-close" && s.wasClosed));
    s.teaser.hidden = !show;
    if (show) {
      copyThemeVars(root, s.teaser);
      document.body.appendChild(s.teaser);
      s.teaser.setAttribute("data-position", ui.position || "bottom-left");
    }
  }

  function closeSurface(root, opts) {
    opts = opts || {};
    var s = root._aogenSurface;
    if (!s) return;
    if (opts.fromSubmit || opts.fromSubmitKeepOpen) {
      s.submitted = true;
      s.teaserDismissed = true;
      if (s.teaser) s.teaser.hidden = true;
    }
    if (opts.fromSubmitKeepOpen) return;
    root.classList.remove("is-open");
    if (s.overlay) {
      s.overlay.classList.remove("is-open");
      s.overlay.hidden = true;
    }
    if (opts.fromSubmit) {
      return;
    }
    if (opts.fromUserClose) {
      s.wasClosed = true;
      placeCornerTeaser(root);
    }
  }

  function applySubmittedVisibility(root, form, btn, keepOpen) {
    var disc = form.querySelector("[data-aogen-disclaimer]");
    if (keepOpen) {
      var fields = form.querySelector("[data-aogen-fields]");
      if (fields) fields.hidden = true;
      if (btn) btn.hidden = true;
      if (disc) disc.hidden = true;
      closeSurface(root, { fromSubmitKeepOpen: true });
      return;
    }
    form.hidden = true;
    if (disc) disc.hidden = true;
    closeSurface(root, { fromSubmit: true });
  }

  function openSurface(root, reason) {
    var s = root._aogenSurface;
    var ui = root._aogenUi || {};
    var display = ui.display || ui.mode || "inline";
    if (!s || display === "inline" || display === "sticky") return;

    if ((reason === "scroll" || reason === "exit") && sessionShown(root)) {
      return;
    }

    if (s.teaser) s.teaser.hidden = true;
    if (s.overlay) {
      var panel = s.overlay.querySelector(".aogen-forms-panel");
      if (panel) panel.hidden = false;
      copyThemeVars(root, s.overlay);
      document.body.appendChild(s.overlay);
      s.overlay.hidden = false;
      s.overlay.classList.add("is-open");
      syncOverlayAttrs(root);
    }
    root.classList.add("is-open");
    if (reason === "scroll" || reason === "exit") markSessionShown(root);
    recordDisplayView(root, formKeyFor(root));
  }

  function syncOverlayAttrs(root) {
    var s = root._aogenSurface;
    var ui = root._aogenUi || {};
    if (!s || !s.overlay) return;
    var display = ui.display || "";
    var isDrawer = display === "drawer";
    var style = ui.popup_style || "overlay";
    var pos = ui.position || "bottom-left";
    var side = ui.drawer_side || "right";
    var template = ui.template || "card";
    s.overlay.setAttribute("data-popup-style", style);
    s.overlay.setAttribute("data-template", template);
    s.overlay.setAttribute("data-drawer-side", side);
    if (isDrawer) {
      s.overlay.removeAttribute("data-position");
    } else {
      s.overlay.setAttribute("data-position", pos);
    }
    s.overlay.classList.toggle("is-floating", !isDrawer && style === "floating" && display === "popup");
    s.overlay.classList.toggle("is-overlay", !isDrawer && !(style === "floating" && display === "popup"));
    s.overlay.classList.toggle("is-drawer-surface", isDrawer);

    var panel = s.overlay.querySelector(".aogen-forms-panel");
    if (panel && panel.style) {
      if (isDrawer) {
        panel.style.transform = "none";
        panel.style.left = "";
        panel.style.right = "";
        panel.style.top = "";
        panel.style.bottom = "";
        panel.style.inset = "";
        panel.style.margin = "";
      } else {
        panel.style.transform = "";
      }
    }
  }

  function ensureOverlay(root, panel) {
    var s = root._aogenSurface;
    if (s.overlay) {
      if (panel && !s.overlay.contains(panel)) s.overlay.appendChild(panel);
      copyThemeVars(root, s.overlay);
      return s.overlay;
    }
    var ov = el("div", { className: "aogen-forms-overlay aogen-forms-overlay--ported" });
    ov.hidden = true;
    ov.setAttribute("role", "dialog");
    ov.setAttribute("aria-modal", "true");
    ov.appendChild(panel);
    ov.addEventListener("click", function (e) {
      if (e.target !== ov) return;
      var ui = root._aogenUi || {};
      if (ui.popup_style === "floating" && (ui.display || "") === "popup") return;
      closeSurface(root, { fromUserClose: true });
    });
    if (!panel.querySelector(".aogen-forms-close")) {
      var close = el("button", {
        type: "button",
        className: "aogen-forms-close",
        "aria-label": "Close",
        text: "×",
      });
      close.addEventListener("click", function () {
        closeSurface(root, { fromUserClose: true });
      });
      panel.insertBefore(close, panel.firstChild);
    }
    s.overlay = ov;
    copyThemeVars(root, ov);
    document.body.appendChild(ov);
    return ov;
  }

  function ensureCornerTeaser(root) {
    var s = root._aogenSurface;
    if (s.teaser) return s.teaser;
    var title = root.getAttribute("data-teaser-title") || "Don't miss out!";
    var body = root.getAttribute("data-teaser-body") || "Complete the form to sign up.";
    var teaser = el("div", {
      className: "aogen-forms-corner-teaser",
      hidden: "hidden",
    });
    var x = el("button", {
      type: "button",
      className: "aogen-forms-corner-teaser__x",
      "aria-label": "Dismiss",
      text: "×",
    });
    x.addEventListener("click", function (e) {
      e.stopPropagation();
      s.teaserDismissed = true;
      teaser.hidden = true;
    });
    var openBtn = el("button", {
      type: "button",
      className: "aogen-forms-corner-teaser__open",
    });
    openBtn.appendChild(el("strong", { className: "aogen-forms-corner-teaser__title", text: title }));
    openBtn.appendChild(el("span", { className: "aogen-forms-corner-teaser__body", text: body }));
    openBtn.addEventListener("click", function () {
      openSurface(root, "click");
    });
    teaser.appendChild(x);
    teaser.appendChild(openBtn);
    s.teaser = teaser;
    copyThemeVars(root, teaser);
    return teaser;
  }

  function ensureStickyBar(root) {
    var s = root._aogenSurface;
    if (s.sticky) return s.sticky;
    var ui = root._aogenUi || {};
    var copy =
      fillTemplate(ui.title_template || ui.title || "", mergeContext(root)) ||
      root.getAttribute("data-button-label") ||
      "Join";
    var bar = el("div", { className: "aogen-forms-sticky-bar" });
    bar.appendChild(el("span", { className: "aogen-forms-sticky-bar__copy", text: copy }));
    var join = el("button", {
      type: "button",
      className: "aogen-forms-sticky-bar__cta",
      text: root.getAttribute("data-button-label") || "Open",
    });
    join.addEventListener("click", function () {
      var panel = panelFor(root);
      if (!panel) return;
      panel.hidden = false;
      var ov = ensureOverlay(root, panel);
      document.body.appendChild(ov);
      ov.setAttribute("data-drawer-side", "bottom");
      ov.setAttribute("data-popup-style", "overlay");
      ov.setAttribute("data-template", (root._aogenUi && root._aogenUi.template) || "card");
      ov.removeAttribute("data-position");
      ov.classList.add("is-drawer-surface", "is-open");
      ov.classList.remove("is-floating", "is-overlay");
      if (panel) {
        panel.hidden = false;
        if (panel.style) {
          panel.style.transform = "none";
          panel.style.left = "";
          panel.style.right = "";
          panel.style.top = "";
          panel.style.bottom = "";
        }
      }
      ov.hidden = false;
      root.classList.add("is-open", "is-popup", "is-drawer");
      if (s.teaser) s.teaser.hidden = true;
      recordDisplayView(root, formKeyFor(root));
    });
    var dismiss = el("button", {
      type: "button",
      className: "aogen-forms-sticky-bar__x",
      "aria-label": "Dismiss",
      text: "×",
    });
    dismiss.addEventListener("click", function () {
      bar.hidden = true;
      s.stickyDismissed = true;
    });
    bar.appendChild(join);
    bar.appendChild(dismiss);
    s.sticky = bar;
    copyThemeVars(root, bar);
    document.body.appendChild(bar);
    if (!root._aogenStickyViewRecorded) {
      root._aogenStickyViewRecorded = true;
      recordDisplayView(root, formKeyFor(root));
    }
    return bar;
  }

  function armTriggers(root) {
    var s = root._aogenSurface;
    var ui = root._aogenUi || {};
    if (!s) return;
    if (s.delayTimer) clearTimeout(s.delayTimer);
    if (s.onScroll) window.removeEventListener("scroll", s.onScroll);
    if (s.onExit) document.removeEventListener("mouseout", s.onExit);
    s.delayTimer = null;
    s.onScroll = null;
    s.onExit = null;

    var display = ui.display || ui.mode || "inline";
    if (display === "inline" || display === "sticky") return;

    var trigger = ui.trigger || "click";
    if (trigger === "click") {
      placeCornerTeaser(root);
      return;
    }
    if (trigger === "load") {
      openSurface(root, "load");
      return;
    }
    if (trigger === "delay") {
      s.delayTimer = setTimeout(function () {
        openSurface(root, "delay");
      }, 2000);
      return;
    }
    if (trigger === "scroll") {
      s.onScroll = function () {
        var doc = document.documentElement;
        var max = doc.scrollHeight - window.innerHeight;
        if (max <= 0) return;
        if (window.scrollY / max >= 0.5) {
          window.removeEventListener("scroll", s.onScroll);
          s.onScroll = null;
          openSurface(root, "scroll");
        }
      };
      window.addEventListener("scroll", s.onScroll, { passive: true });
      return;
    }
    if (trigger === "exit") {
      s.onExit = function (e) {
        if (!e) return;
        if (e.clientY > 0) return;
        document.removeEventListener("mouseout", s.onExit);
        s.onExit = null;
        openSurface(root, "exit");
      };
      document.addEventListener("mouseout", s.onExit);
    }
  }

  function applyUi(root, ui) {
    disposeSurfaces(root);

    if (root.getAttribute("data-theme-styles") !== "1") {
      var colors = (ui && ui.colors) || {};
      root.style.setProperty("--aogen-forms-bg", colors.background || "#ffffff");
      root.style.setProperty("--aogen-forms-text", colors.text || "#111111");
      root.style.setProperty("--aogen-forms-btn", colors.button || "#111111");
      root.style.setProperty("--aogen-forms-btn-text", colors.button_text || "#ffffff");
    }

    var panel = root.querySelector(".aogen-forms-panel");
    root._aogenUi = ui || {};
    root._aogenSurface = {
      overlay: null,
      teaser: null,
      sticky: null,
      wasClosed: false,
      teaserDismissed: false,
      stickyDismissed: false,
      submitted: false,
      delayTimer: null,
      onScroll: null,
      onExit: null,
      onEsc: null,
    };

    var display = (ui && (ui.display || ui.mode)) || "inline";
    var isOverlaySurface = display === "popup" || display === "drawer";
    root.setAttribute("data-display", display);
    root.setAttribute("data-template", (ui && ui.template) || "card");
    root.setAttribute("data-popup-style", (ui && ui.popup_style) || "overlay");
    root.setAttribute("data-position", (ui && ui.position) || "bottom-left");
    root.setAttribute("data-drawer-side", (ui && ui.drawer_side) || "right");
    root.setAttribute("data-teaser", (ui && ui.teaser) || "after-close");
    root.setAttribute("data-trigger", (ui && ui.trigger) || "click");
    root.classList.toggle("is-popup", isOverlaySurface);
    root.classList.toggle("is-drawer", display === "drawer");
    root.classList.toggle("is-sticky", display === "sticky");
    root.classList.toggle(
      "is-floating",
      !!(ui && ui.popup_style === "floating" && display === "popup"),
    );
    ["minimal", "card", "split"].forEach(function (t) {
      root.classList.remove("aogen-forms-template--" + t);
    });
    root.classList.add("aogen-forms-template--" + ((ui && ui.template) || "card"));

    if (display === "inline" || !panel) {
      root.classList.remove("is-open");
      if (panel) panel.hidden = false;
      return;
    }

    if (display === "sticky") {
      panel.hidden = true;
      if (!root._aogenSurface.stickyDismissed) ensureStickyBar(root);
      bindEscapeClose(root);
      return;
    }

    /* Popup / drawer: keep panel hidden in-page until overlay opens (no submit-button FOUC). */
    panel.hidden = true;
    ensureCornerTeaser(root);

    var trigger = (ui && ui.trigger) || "click";
    var inlineTeaser = root.querySelector(".aogen-forms-teaser");
    if (trigger === "click") {
      if (!inlineTeaser) {
        inlineTeaser = el("button", {
          type: "button",
          className: "aogen-forms-teaser",
          text: root.getAttribute("data-button-label") || "Open form",
        });
        inlineTeaser.addEventListener("click", function () {
          openSurface(root, "click");
        });
        root.insertBefore(inlineTeaser, root.firstChild);
      }
    } else if (inlineTeaser) {
      inlineTeaser.remove();
    }

    bindEscapeClose(root);
  }

  function bindEscapeClose(root) {
    if (!root || !root._aogenSurface || root._aogenSurface.onEsc) return;
    root._aogenSurface.onEsc = function (e) {
      if (e.key === "Escape" && root.classList.contains("is-open")) {
        closeSurface(root, { fromUserClose: true });
      }
    };
    document.addEventListener("keydown", root._aogenSurface.onEsc);
  }

  /** Call after head/fields are filled so popup/drawer content is not empty. */
  function activateOverlaySurfaces(root) {
    var ui = root._aogenUi || {};
    var display = ui.display || ui.mode || "inline";
    if (display !== "popup" && display !== "drawer") return;
    var panel = panelFor(root);
    if (!panel || !root._aogenSurface) return;
    ensureOverlay(root, panel);
    syncOverlayAttrs(root);
    placeCornerTeaser(root);
    armTriggers(root);
  }

  function collectSubmitted(form) {
    var submitted = {};
    var fd = new FormData(form);
    var multiKeys = {};
    form.querySelectorAll('input[data-multiselect="1"]').forEach(function (inp) {
      multiKeys[inp.name] = true;
    });
    Object.keys(multiKeys).forEach(function (k) {
      submitted[k] = [];
    });
    fd.forEach(function (value, key) {
      if (multiKeys[key]) {
        submitted[key].push(value);
        return;
      }
      if (form.querySelector('input[data-file-field="' + key + '"]')) return;
      submitted[key] = value;
    });
    Object.keys(submitted).forEach(function (k) {
      if (submitted[k] === "true" || submitted[k] === "on") {
        var consentish = form.querySelector(
          'input[name="' + k + '"][type="checkbox"]:not([data-multiselect])',
        );
        if (consentish) submitted[k] = true;
      }
    });
    var schema = form.closest(".aogen-forms-block") && form.closest(".aogen-forms-block")._aogenFieldsSchema;
    if (Array.isArray(schema)) {
      schema.forEach(function (field) {
        if (!field || !field.key) return;
        if (normalizeType(field.type) !== "consent") return;
        if (consentStyle(field) === "notice") submitted[field.key] = true;
      });
    }
    return submitted;
  }

  function readFileAsPayload(file) {
    return new Promise(function (resolve, reject) {
      if (!file) return resolve(null);
      if (file.size > 2 * 1024 * 1024) {
        reject(new Error("File too large (max 2MB)"));
        return;
      }
      var reader = new FileReader();
      reader.onload = function () {
        var result = String(reader.result || "");
        var m = result.match(/^data:([^;]+);base64,(.+)$/);
        if (!m) {
          reject(new Error("Could not read file"));
          return;
        }
        resolve({
          name: file.name,
          mime: m[1],
          size: file.size,
          data_base64: m[2],
        });
      };
      reader.onerror = function () {
        reject(new Error("Could not read file"));
      };
      reader.readAsDataURL(file);
    });
  }

  function teardown(root) {
    disarmClickBind(root);
    disarmDisplayViewTracking(root);
    disposeSurfaces(root);
    if (root._aogenAbort) {
      try {
        root._aogenAbort.abort();
      } catch (e) {}
      root._aogenAbort = null;
    }
    root.removeAttribute(ATTR_MOUNTED);
    root.removeAttribute("data-aogen-ready");
    root.removeAttribute("data-aogen-error");
    if (root._aogenUnlockTimer) {
      try {
        clearTimeout(root._aogenUnlockTimer);
      } catch (e) {}
      root._aogenUnlockTimer = null;
    }
    root._aogenRenderedAt = null;
    root._aogenBookingContext = null;
    root._aogenOpenPopupWhenReady = false;
    root._aogenBookingPopupOpen = false;
    var fieldsHost = fieldsHostFor(root) || root.querySelector("[data-aogen-fields]");
    if (fieldsHost) fieldsHost.innerHTML = "";
    var head = headFor(root) || root.querySelector("[data-aogen-head]");
    if (head) head.innerHTML = "";
    var discForm =
      (panelFor(root) && panelFor(root).querySelector(".aogen-forms-form")) ||
      root.querySelector(".aogen-forms-form");
    var discHost = discForm ? discForm.querySelector("[data-aogen-disclaimer]") : null;
    if (discHost) discHost.innerHTML = "";
    var form =
      (panelFor(root) && panelFor(root).querySelector(".aogen-forms-form")) ||
      root.querySelector(".aogen-forms-form");
    if (form) form.hidden = false;
    var panel = panelFor(root) || root.querySelector(".aogen-forms-panel");
    if (panel) panel.hidden = true;
    var btn = root.querySelector('button[type="submit"]');
    if (btn) {
      btn.disabled = true;
      btn.removeAttribute("aria-busy");
    }
    var inlineTeaser = root.querySelector(".aogen-forms-teaser");
    if (inlineTeaser) inlineTeaser.remove();
  }

  function mountBlock(root, force) {
    if (!root || !root.classList || !root.classList.contains("aogen-forms-block")) return;

    var form = root.querySelector(".aogen-forms-form");
    var fieldsHost = root.querySelector("[data-aogen-fields]");
    var msg = root.querySelector(".aogen-forms-msg");
    var formKey = (root.getAttribute("data-form-key") || "").trim();
    var mountedKey = root.getAttribute(ATTR_MOUNTED) || "";

    if (!force && mountedKey && mountedKey === formKey) return;

    if (formKey && mountedKey && mountedKey !== formKey) {
      root._aogenInlineViewRecorded = false;
      root._aogenStickyViewRecorded = false;
    }

    teardown(root);

    if (!form || !fieldsHost) {
      setMessage(msg, "Form markup is incomplete.", true);
      return;
    }
    if (!formKey) {
      setMessage(msg, "Set a Form key that matches an active form in AOGEN Connect.", true);
      return;
    }
    if (!apiBase(root)) {
      setMessage(
        msg,
        "Set AOGEN API base URL in the block (dev.adapter… or adapter.aogen.com.au).",
        true,
      );
      return;
    }
    if (!shopDomain(root)) {
      setMessage(msg, "Missing shop domain on the form block.", true);
      return;
    }

    var abort = typeof AbortController !== "undefined" ? new AbortController() : null;
    root._aogenAbort = abort;
    var signal = abort ? abort.signal : undefined;
    var ctx = mergeContext(root);
    var loadGen = (root._aogenLoadGen || 0) + 1;
    root._aogenLoadGen = loadGen;

    setMessage(msg, "", false);
    root.setAttribute(ATTR_MOUNTED, formKey);

    var btnInit = form.querySelector('button[type="submit"]');
    if (btnInit) {
      btnInit.disabled = true;
      btnInit.setAttribute("aria-busy", "true");
    }

    fetchFormsApi(definitionUrl(root, formKey), { signal: signal })
      .then(function (packed) {
        return packed.result;
      })
      .then(function (result) {
        if (root._aogenLoadGen !== loadGen) return;
        if (!result.ok || !result.body || !result.body.ok) {
          setMessage(msg, explainLoadFailure(result), true);
          if (btnInit) {
            btnInit.disabled = true;
            btnInit.removeAttribute("aria-busy");
          }
          return;
        }

        var schema = Array.isArray(result.body.fields_schema) ? result.body.fields_schema : [];
        var ui = result.body.ui && typeof result.body.ui === "object" ? result.body.ui : {};
        applyUi(root, ui);

        var head = headFor(root);
        if (head) {
          head.innerHTML = "";
          var title = fillTemplate(ui.title_template || ui.title || "", ctx);
          var intro = fillTemplate(ui.intro_template || ui.intro || "", ctx);
          if (title) head.appendChild(el("h3", { className: "aogen-forms-title", text: title }));
          if (intro) head.appendChild(el("p", { className: "aogen-forms-intro", text: intro }));
        }

        var liveFieldsHost = fieldsHostFor(root) || fieldsHost;
        liveFieldsHost.innerHTML = "";
        var renderSchema = schema.map(function (field) {
          if (field && field.type === "consent" && (ui.consent_text || field.label)) {
            return Object.assign({}, field, { label: ui.consent_text || field.label });
          }
          return field;
        });
        root._aogenFieldsSchema = renderSchema;
        renderSchema.forEach(function (field) {
          var node = renderField(field, ctx);
          if (node) liveFieldsHost.appendChild(node);
        });
        renderConsentNotices(root, renderSchema, ctx);

        var btn = (panelFor(root) || root).querySelector('button[type="submit"]');
        var btnLabel = root.getAttribute("data-button-label");
        if (btn && btnLabel) btn.textContent = btnLabel;
        root.removeAttribute("data-aogen-error");
        root.setAttribute("data-aogen-ready", "1");
        root._aogenRenderedAt = Date.now();
        /* Keep submit locked until timing window elapses — avoids silent server camouflage on fast fills */
        if (btn) {
          btn.disabled = true;
          btn.removeAttribute("aria-busy");
          if (root._aogenUnlockTimer) clearTimeout(root._aogenUnlockTimer);
          root._aogenUnlockTimer = setTimeout(function () {
            root._aogenUnlockTimer = null;
            if (root.getAttribute("data-aogen-ready") === "1") btn.disabled = false;
          }, 2000);
        }

        root._aogenSuccess = normalizeSuccess(ui);
        root._aogenSuccessTpl = root._aogenSuccess.message || "";
        activateOverlaySurfaces(root);
        armClickBind(root);
        if (root._aogenBookingContext) refreshBookingContextUi(root);
        if (root._aogenOpenPopupWhenReady) {
          root._aogenOpenPopupWhenReady = false;
          forceOpenBookingPopup(root);
        }
        armInlineDisplayViewTracking(root, formKey);
        pushDataLayer("waitlist_form_view", mergeContext(root));

        if (!root.getAttribute("data-start-bound")) {
          root.setAttribute("data-start-bound", "1");
          var started = false;
          form.addEventListener(
            "focusin",
            function (e) {
              if (started) return;
              var t = e.target;
              if (!t || (t.name !== "name" && t.name !== "email")) return;
              if (t.type === "checkbox" || t.type === "hidden") return;
              started = true;
              pushDataLayer("waitlist_form_start", mergeContext(root));
            },
            true,
          );
        }
      })
      .catch(function (err) {
        if (err && err.name === "AbortError") return;
        if (root._aogenLoadGen !== loadGen) return;
        setMessage(
          msg,
          "Could not load form (network). Check API base URL and DevTools → Network for /api/public/forms/definition.",
          true,
        );
        if (btnInit) {
          btnInit.disabled = true;
          btnInit.removeAttribute("aria-busy");
        }
      });

    if (root.getAttribute("data-submit-bound") === "1") return;
    root.setAttribute("data-submit-bound", "1");

    form.addEventListener("submit", function (ev) {
      ev.preventDefault();
      if (root.getAttribute("data-aogen-ready") !== "1") {
        setMessage(msg, "Form is still loading or failed to load.", true);
        return;
      }
      var liveKey = (root.getAttribute("data-form-key") || "").trim();
      var liveCtx = mergeContext(root);
      var schema = root._aogenFieldsSchema || [];
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      clearFieldInvalid(form);
      setMessage(msg, "", false);

      if (schemaRequiresVenue(schema) && !String(liveCtx.venue_id || "").trim()) {
        setMessage(msg, "Select a location first.", true);
        pushDataLayer("waitlist_form_error", liveCtx, { error_type: "venue_required" });
        if (btn) btn.disabled = false;
        return;
      }

      var localErrors = validateLocalSubmission(form, schema);
      if (localErrors.length) {
        localErrors.forEach(function (e) {
          markFieldInvalid(form, e.field);
        });
        setMessage(msg, formatValidationDetails(localErrors, schema), true);
        pushDataLayer("waitlist_form_error", liveCtx, { error_type: localErrorType(localErrors) });
        if (btn) btn.disabled = false;
        var firstBad =
          form.querySelector("[aria-invalid='true']") ||
          form.querySelector(nameSelector(localErrors[0].field));
        if (firstBad && typeof firstBad.focus === "function") firstBad.focus();
        return;
      }

      var submitted = mergeHiddenAutoFrom(collectSubmitted(form), schema, liveCtx);
      var fileInputs = form.querySelectorAll("input[data-file-field]");
      var fileJobs = [];
      fileInputs.forEach(function (inp) {
        var f = inp.files && inp.files[0];
        if (f) {
          fileJobs.push(
            readFileAsPayload(f).then(function (payload) {
              submitted[inp.getAttribute("data-file-field")] = payload;
            }),
          );
        }
      });

      Promise.all(fileJobs)
        .then(function () {
          var payload = {
            shop: shopDomain(root),
            form_key: liveKey,
            submitted_data: submitted,
            source_url: window.location.href,
          };
          if (root._aogenRenderedAt) payload.rendered_at = root._aogenRenderedAt;
          return fetchFormsApi(submitUrl(root), {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          });
        })
        .then(function (packed) {
          return packed.result;
        })
        .then(function (result) {
          if (result.passwordWall) {
            setMessage(msg, explainLoadFailure(result), true);
            if (btn) btn.disabled = false;
            return;
          }
          if (result.ok && result.body && result.body.ok) {
            var successCfg = root._aogenSuccess || normalizeSuccess({});
            var redirectUrl =
              successCfg.action === "redirect" ? resolveRedirectUrl(successCfg.redirect_url) : "";
            // Conversion pixels only for real accepts (camouflage is { ok: true } without id).
            trackFormSubmitSuccess(root, liveCtx, result.body);
            if (redirectUrl) {
              redirectAfterSubmit(redirectUrl);
              return;
            }
            var successTpl = root._aogenSuccessTpl || "";
            var successHeading = successCfg.heading ? fillTemplate(successCfg.heading, liveCtx) : "";
            var successBody =
              fillTemplate(successTpl, liveCtx) ||
              root.getAttribute("data-success") ||
              "Thanks!";
            var responseCode =
              result.body && result.body.discount_code
                ? String(result.body.discount_code).trim()
                : "";
            var responsePending = !!(result.body && result.body.discount_pending);
            var discCfg = successCfg.discount;
            var showIssuedDiscount =
              successCfg.action !== "redirect" &&
              responseCode &&
              (!discCfg || discCfg.mode === "shared" || discCfg.mode === "unique");
            var showSharedFromDef =
              successCfg.action !== "redirect" &&
              !responseCode &&
              !responsePending &&
              discCfg &&
              discCfg.mode !== "unique" &&
              discCfg.code;
            var hasDiscountSuccess = !!(showIssuedDiscount || showSharedFromDef);
            if (showIssuedDiscount) {
              renderSuccessContent(
                root,
                {
                  action: successCfg.action,
                  heading: successCfg.heading,
                  message: successCfg.message,
                  discount: {
                    gid: (discCfg && discCfg.gid) || "",
                    code: responseCode,
                    title: (discCfg && discCfg.title) || "",
                  },
                },
                liveCtx,
              );
            } else if (showSharedFromDef) {
              renderSuccessContent(root, successCfg, liveCtx);
            } else if (responsePending && successCfg.action !== "redirect") {
              setMessage(
                msg,
                (successHeading ? successHeading + "\n\n" : "") +
                  successBody +
                  "\n\nYour unique discount code is being prepared. If you have an account email, it can arrive via store automation shortly.",
                false,
              );
            } else {
              setMessage(
                msg,
                successHeading ? successHeading + "\n\n" + successBody : successBody,
                false,
              );
            }
            applySubmittedVisibility(
              root,
              form,
              btn,
              hasDiscountSuccess || (responsePending && successCfg.action !== "redirect"),
            );
          } else {
            var details = result.body && Array.isArray(result.body.details) ? result.body.details : [];
            details.forEach(function (d) {
              if (d && d.field) markFieldInvalid(form, d.field);
            });
            setMessage(msg, explainSubmitFailure(result, schema), true);
            pushDataLayer("waitlist_form_error", liveCtx, {
              error_type: (result.body && (result.body.error || result.body.error_code)) || "server_error",
            });
            if (btn) btn.disabled = false;
          }
        })
        .catch(function (err) {
          if (err && err.name === "AbortError") return;
          setMessage(msg, (err && err.message) || "Network error. Please try again.", true);
          pushDataLayer("waitlist_form_error", liveCtx, { error_type: "server_error" });
          if (btn) btn.disabled = false;
        });
    });
  }

  function mountAll(scope, force) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll(".aogen-forms-block").forEach(function (node) {
      mountBlock(node, !!force);
    });
  }

  function onThemeEditorEvent(event) {
    var target = (event && event.target) || document;
    mountAll(target, true);
  }

  function boot() {
    mountAll(document, false);

    document.addEventListener("aogen:booking-context", handleBookingContextEvent);

    document.addEventListener("shopify:section:load", onThemeEditorEvent);
    document.addEventListener("shopify:section:reorder", onThemeEditorEvent);
    document.addEventListener("shopify:block:select", onThemeEditorEvent);

    // Theme editor sometimes updates block settings without section:load
    if (typeof MutationObserver !== "undefined") {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.type === "attributes" && m.attributeName === "data-form-key") {
            mountBlock(m.target, true);
          }
          if (m.type === "childList") {
            m.addedNodes.forEach(function (node) {
              if (node.nodeType !== 1) return;
              if (node.classList && node.classList.contains("aogen-forms-block")) {
                mountBlock(node, true);
              } else if (node.querySelectorAll) {
                node.querySelectorAll(".aogen-forms-block").forEach(function (el) {
                  mountBlock(el, true);
                });
              }
            });
          }
        }
      });
      observer.observe(document.documentElement, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ["data-form-key"],
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
